import { useMutation } from "@tanstack/react-query";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useRef, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DCSQueryClient } from "../../../../queryClient";
import { UserRoles } from "../../../../constants/userRoles";
import { useToast } from "../../../../Providers/ToastProvider";
import { useUser } from "../../../../keycloak";
import { requests } from "../../../../services/http-common";
import { ConfirmationModal } from "../../../../components/ConfirmationModal/ConfirmationModal";
import { EmployeeStatuses } from "../../../../models/Employee";

export const Actions = (rowData: {
  id: string;
  isDisabled: boolean;
  status: EmployeeStatuses;
}) => {
  const menu = useRef(null);
  const navigate = useNavigate();
  const { show } = useToast();
  const user: any = useUser();
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);

  const deleteEmployee = useMutation({
    mutationFn: () => {
      return requests.delete(`/user/${rowData.id}`);
    },
    onSuccess: () => {
      show({ detail: "The employee was deleted successfully !" });
      DCSQueryClient.invalidateQueries({ queryKey: ["employee-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  const items = useMemo(() => {
    let _items: any = [];

    if (user?.roles.dcs_client.includes(UserRoles.USER_VIEW)) {
      _items.push({
        label: "View",
        command: () => {
          navigate(`/management/employees/${rowData.id}/details`);
        },
      });
    }
    if (
      user?.roles.dcs_client.includes(UserRoles.USER_UPDATE) &&
      rowData.status !== EmployeeStatuses.TERMINATED
    ) {
      _items.push({
        label: "Edit",
        command: () => {
          navigate(`/management/employees/${rowData.id}/details/edit`);
        },
      });
    }
    if (user?.roles.dcs_client.includes(UserRoles.USER_DELETE)) {
      _items.push({
        label: "Delete",
        command: () => {
          setShowDeletePopup(true);
        },
      });
    }

    return _items;
  }, [rowData.id, deleteEmployee, navigate, user]);

  return (
    <>
      <Menu model={items} popup ref={menu} id="popup_menu" />
      <ConfirmationModal
        visible={showDeletePopup}
        onHide={() => setShowDeletePopup(false)}
        accept={() => deleteEmployee.mutate()}
        reject={() => setShowDeletePopup(false)}
      />
      <Button
        icon="pi pi-ellipsis-v"
        //@ts-ignore
        onClick={(event) => menu.current.toggle(event)}
        aria-controls="popup_menu"
        aria-haspopup
        className="p-button-rounded p-button-text"
        disabled={!items.length || rowData.isDisabled}
      />
    </>
  );
};
